import type { Policy } from '@mls-wallet/shared-types';

/**
 * Convert policy type enum to human-readable label
 */
export function getPolicyTypeLabel(type: Policy['type']): string {
  switch (type) {
    case 'AUTO_APPROVAL':
      return 'Auto Approval';
    case 'MANUAL_APPROVAL':
      return 'Manual Approval';
    default:
      return type;
  }
}

/**
 * Convert transaction type enum to human-readable label
 */
export function getTransactionTypeLabel(
  transactionType: Policy['transactionType']
): string {
  switch (transactionType) {
    case 'TOKEN_TRANSFER':
      return 'Token Transfer';
    case 'CONTRACT_INTERACTION':
      return 'Contract Interaction';
    case 'ANY':
      return 'Any transaction type';
    default:
      return transactionType;
  }
}

/**
 * Format Ethereum address to short form (0x1234...5678)
 */
export function formatAddress(address?: string): string {
  if (!address) return '';
  return (
    address.substring(0, 6) + '...' + address.substring(address.length - 4)
  );
}
